




















import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { axios, ZYToast } from '@zyf2e/adapt';

let timer: NodeJS.Timeout;
@Component
export default class PayConfirm extends Vue {
  countTime = 0;

  @Prop({ type: String, default: '/trade-service/1.0.0/queryPayResult' })
  apiUrl: string;

  mounted() {
    this.handleConfim();
  }

  countDown() {
    clearTimeout(timer);
    const wait = this.countTime < 3 ? 2000 : 5000;
    if (this.countTime >= 10) return;
    this.countTime += 1;
    timer = setTimeout(() => {
      this.checkPaySuccess();
    }, wait);
  }

  @Watch('status')
  watchstatus() {
    if (this.status === 1 || this.status === 2) {
      document.title = '支付成功';
    } else if (this.status === 3) {
      document.title = '支付失败';
    } else {
      document.title = '支付确认';
    }
  }

  get formatSeconds() {
    return `00:0${this.countTime}`;
  }

  get status() {
    return this.$route.query.status ? Number(this.$route.query.status) : null;
  }

  get bizId() {
    return this.$route.query.bizId;
  }

  get tradeNo() {
    return this.$route.query.tradeNo;
  }

  get orderInfo() {
    return this.$route.query;
  }

  reload() {
    this.countTime = 0;
    this.handleConfim();
  }

  async checkPaySuccess() {
    ZYToast.setOnceConfig({ noToast: true });
    const {
      data: { tradeStatus }
    } = await axios.post(this.apiUrl, {
      tradeNo: this.tradeNo,
      queryThirdPlatform: true
    });
    ZYToast.clearOnceConfig();
    this.$router.replace({
      ...this.$route,
      query: { ...this.$route.query, status: String(tradeStatus) }
    });
    this.handleConfim();
  }

  handleConfim() {
    // 处理支付操作 显示倒计时
    if (this.status === 1 || this.status === 2) {
      this.$emit('onSuccess', this.orderInfo);
    } else if (this.status === 3) {
      setTimeout(() => {
        this.$emit('onFail', this.orderInfo);
      }, 1000); // 延迟1秒 方便后退操作
    } else {
      this.countDown();
    }
  }
}
